module.exports = __webpack_public_path__ + "img/homepage-interest-orange.fdb60fb8.svg";